// extracted by mini-css-extract-plugin
export default {"list":"_D6kaWsO","legacy":"UOleZL1F"};